import { ActionType, createAsyncAction } from "typesafe-actions";

import FileTag from "@mapmycustomers/shared/types/entity/FileTag";

export const fetchAllFileTags = createAsyncAction(
  "@fileTags/fetchAllFileTags/request",
  "@fileTags/fetchAllFileTags/success",
  "@fileTags/fetchAllFileTags/failure"
)<void, FileTag[], void>();

export type Actions = ActionType<typeof fetchAllFileTags>;
